export const esTranslations = {
  PER_PAGE: 'por página',
  OF: 'de',
  ITEMS: 'elementos',
  PREVIOUS: 'Anterior',
  NEXT: 'Siguiente',
};
